<template>
  <app-dropdown :title="$t('header.filters.epoch.title')"
                class="epoch-selector"
                ref="dropdown"
                @close="onDropdownClose"
  >
    <template #label>
      <div class="tags-selector__selected-tags">
        <app-tag v-for="filter in activeFilters"
                 :key="`${ filter.type }-${ filter.id }`"
                 readonly
                 :value="true"
                 :class="{'has-plus': showActiveFiltersPlus}"
        >
          <span v-html="getTextFromHtmlString(filter.periodLabel)"></span>
        </app-tag>
        <app-tag v-if="showActiveFiltersPlus"
                 readonly
                 :value="true"
                 class="tags-selector__selected-tags__plus"
        >
          {{ $t('header.filters.tags.selectedTagsPlus') }}
        </app-tag>
      </div>
    </template>

    <div class="epoch-selector__dropdown">
      <epoch-selector-item v-for="epoch in sortedEpochs"
                           :key="epoch.id"
                           :filter="epoch"
                           filter-type="epochs"
      />
    </div>

    <selector-controls @clear="clearFilters"
                       @apply="applyFilters"
                       :is-filter-active="isFilterActive"
    />

    <transition name="fade">
      <div class="epoch-selector__is-loading-overlay"
           v-if="isActiveFiltersLoading"
      >
        <div class="loader"
        />
      </div>
    </transition>
  </app-dropdown>
</template>

<script>
import AppDropdown from "@/components/common/AppDropdown/AppDropdown";
import AppTag from "@/components/common/AppTag/AppTag";
import EpochSelectorItem from "@/components/common/TheHeader/EpochSelector/EpochSelectorItem";
import SelectorControls from "@/components/common/TheHeader/SelectorControls/SelectorControls";
import { mapState, mapActions } from "vuex";
import { ACTIVE_FILTERS_LABELS_COUNT } from "@/config/filters";
import getTextFromHtmlString from "@/helpers/getTextFromHtmlString";

export default {
  name: "EpochSelector",
  components: {
    AppDropdown,
    AppTag,
    EpochSelectorItem,
    SelectorControls
  },
  computed: {
    ...mapState('Filters', ['epochs', 'isActiveFiltersLoading']),

    sortedEpochs() {
      return [...this.epochs]
        .sort((epochB, epochA) => {
          return (!epochA.from && !epochB.from ? 0
            : !epochA.from ? -1
            : !epochB.from ? 1
            : epochA.from > epochB.from ? 1
            : epochA.from === epochB.from ? 0 : -1)
            || (epochA.to > epochB.to ? 1 : epochA.to === epochB.to ? 0 : -1)
        })
    },
    allActiveEpochs() {
      return this.epochs
        .filter(({ isActive }) => isActive)
    },
    activeFilters() {
      return [...this.allActiveEpochs]
        .sort((a, b) => a.name > b.name ? 1 : -1)
        .slice(0, ACTIVE_FILTERS_LABELS_COUNT)
    },
    showActiveFiltersPlus() {
      return this.allActiveEpochs.length > ACTIVE_FILTERS_LABELS_COUNT
    },
    isFilterActive() {
      return this.allActiveEpochs.length > 0
    }
  },
  methods: {
    hideDropdown() {
      this.$refs['dropdown'].hideDropdown()
    },
    onDropdownClose() {
      this.reloadCoordinates()
    },
    clearFilters() {
      this.resetAllFilters()
      this.hideDropdown()
    },
    applyFilters() {
      this.hideDropdown()
    },
    getTextFromHtmlString,

    ...mapActions('Coordinates', ['reloadCoordinates']),
    ...mapActions('Filters', ['resetAllFilters'])
  }
}
</script>

<style lang="scss">
.epoch-selector {
  position: relative;

  &__dropdown {
    max-height: 70vh;
    overflow-y: auto;
    padding: 15px 0;
    display: flex;
    flex-direction: column;
  }

  .app-checkbox {
    display: flex;
    align-items: center;
    width: 100%;
    padding: 11px 16px 10px 10px;

    &__label {
      display: flex;
      justify-content: space-between;
      width: 100%;
      margin-left: 10px;
    }

  }

  &__is-loading-overlay {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba($input-background-color, .6);
    display: flex;
    align-items: center;
    justify-content: center;

    .loader {
      width: 100px;
      height: 100px;
      border-width: 7px;
    }

  }

}

@include smallerThan("md") {
  .epoch-selector {
    &__dropdown {
      max-height: calc(100vh - 240px);
    }
  }
}
</style>
